module.exports = __webpack_public_path__ + "img/ps378cywwwsutsj8pmp8m27gb7hw1flbzk5b5100c3-0adc-4c4a-b3ea-0570406b57a1.84fb0823.png";